import { render, staticRenderFns } from "./Fcf.vue?vue&type=template&id=1a5ff54e&scoped=true&"
import script from "./Fcf.vue?vue&type=script&lang=js&"
export * from "./Fcf.vue?vue&type=script&lang=js&"
import style0 from "./Fcf.vue?vue&type=style&index=0&id=1a5ff54e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5ff54e",
  null
  
)

export default component.exports